import { render, staticRenderFns } from "./InsHeader.vue?vue&type=template&id=53dbdec8&scoped=true"
import script from "./InsHeader.vue?vue&type=script&lang=ts"
export * from "./InsHeader.vue?vue&type=script&lang=ts"
import style0 from "./InsHeader.vue?vue&type=style&index=0&id=53dbdec8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dbdec8",
  null
  
)

export default component.exports